import React from 'react';
import PropTypes from 'prop-types';

const StickyTopHeaderButton: React.FC<Props> = (props: any) => {
  const stickyTopHeaderObj = props.stickyTopHeaderObj;
  const { sectionDesc, actionButton, iconBody } = stickyTopHeaderObj;
  return (
    <div className="top-header-button--wrapper">
      {iconBody && <div className="icon--wrapper bx--col-lg-1">{iconBody}</div>}
      {sectionDesc && (
        <div className="bx--col-sm-15 bx--col-md-15 bx--col-lg-13 bx--no-gutter--left">
          <p>{sectionDesc}</p>
        </div>
      )}
      {actionButton && (
        <div className="bx--col-sm-0 bx--col-md-0 bx--col-lg-2">
          <div className="inside-button--wrapper">{actionButton}</div>
        </div>
      )}
    </div>
  );
};

const propTypes = {
  stickyTopHeaderObj: PropTypes.object
};

type Props = PropTypes.InferProps<typeof propTypes>;

StickyTopHeaderButton.propTypes = propTypes;

StickyTopHeaderButton.defaultProps = {
  stickyTopHeaderObj: {}
};

export default StickyTopHeaderButton;
